<template>
  <vue-simple-spinner></vue-simple-spinner>
</template>

<script>
import SimpleSpinner from 'vue-simple-spinner';

export default {
  components: {
    'vue-simple-spinner': SimpleSpinner
  }
};
</script>

<style>
  div.vue-simple-spinner {
    border-radius: 100% !important;
  }
</style>
